import React, {ChangeEvent, FC} from "react"
import {MarkdownAtom, MarkdownAtomType} from "../../model/markdown/MarkdownText"
import {AtomsViewer} from "./AtomsViewer"

interface AtomViewerProps {
    atom: MarkdownAtom
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const AtomViewer: FC<AtomViewerProps> = ({
                                                    atom,
                                                    onToggleCheckBox
                                                }) => {
    const changeCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault()
        event.stopPropagation()
        onToggleCheckBox(atom)
    }

    switch (atom.type) {
        case MarkdownAtomType.PLAIN:
            return (
                <>{atom.content}</>
            )
        case MarkdownAtomType.ITALIC:
            return (
                <em>{atom.content}</em>
            )
        case MarkdownAtomType.BOLD:
            return (
                <strong>{atom.content}</strong>
            )
        case MarkdownAtomType.LINE_THROUGH:
            return (
                <span className="atomLineThrough">{atom.content}</span>
            )
        case MarkdownAtomType.BOLD_ITALIC:
            return (
                <em><strong>{atom.content}</strong></em>
            )
        case MarkdownAtomType.CODE:
            return (
                <code>{atom.content}</code>
            )
        case MarkdownAtomType.LINK:
            return (
                <a href={atom.url} target="_blank">{atom.content}</a>
            )
        case MarkdownAtomType.CHECKBOX:
            return (
                <input type="checkbox" checked={atom.checked} onChange={changeCheckbox}/>
            )
        case MarkdownAtomType.SUB_BLOCK:
            return (
                <>
                    <AtomsViewer atoms={atom.subAtoms} onToggleCheckBox={onToggleCheckBox}/>
                </>
            )
    }
    return (
        <div>Unknown atom</div>
    )
}
